import {Injectable} from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree
} from '@angular/router';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as EmployeeModels from '@employee-models/index';
import {LocalStorageService} from '@ui-app/services/local-storage.service';
import {UserProfileService} from '@ui-app/services/user-profile.service';


@Injectable({
    providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

    constructor(
        private localStorageService: LocalStorageService,
        private userProfileService: UserProfileService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if (!this.userProfileService.user) {
            return this.userProfileService.getUserData().pipe(
                map((user: EmployeeModels.DM.IUserData) => {
                    if (user && !(user.userRoleIds?.length ? user.userRoleIds : [user.userRoleId]).includes(EmployeeModels.DE.UserRoleEnum.PreHire)) {
                        return true;
                    } else {
                        window.location.assign(`https://${window.location.host}/prehire/index.html`);
                    }
                    return false;
                })
            );
        } else {
            return true;
        }

    }
}
